import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import Label from './Label'
import Link from './Link'
import MobileButtonLink from './MobileButtonLink'
import MenuElement from './MenuElement'
import MenuList from './MenuList'

const Sidebar = styled.div<ISidebarProps>`
  left: 0;
  top: 0;
  display: block;

  width: 240px;
  max-width: 240px;

  z-index: 1299;
  overflow: hidden;
  
  min-height: 568px;
  min-height: var(--full);
  
  position: fixed;

  transform: translateZ(0);
  will-change: auto;
  
  background: #fff;
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);

  transition: width 0.2s ease-in-out;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${isNot('isSidebarOpen')`
    width: 0;
    height: 100%;
    img.big-logo {
      display: none !important;
    }
    img.small-logo {
      height: ${({ size }) => (size ? 20 * size : 20)}px;
      margin-left: ${({ size }) => (size ? -7 * size : -7)}px;
    }
  `};

  & > ${Link} > div * > ${Label},
  & > ${Link} > div > ${Label},
  & > ${MobileButtonLink} > div * > ${Label},
  & > ${MobileButtonLink} > div > ${Label},
  & > ${Label} {
    ${is('isSidebarOpen')`
      width: 240px;
    `};
  }

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    ${isNot('isSidebarOpen')`
      width: ${({ size }) => (size ? 56 * size : 56)}px;
      img.small-logo {
        display: block !important;
      }
    `}

    ${MenuElement},
    ${MenuElement} > ${Link} > div,
    ${MenuElement} > ${MobileButtonLink} > div {
      ${isNot('isSidebarOpen')`
        justify-content: center;
      `}

      & > ${MenuList},
      & > ${Link} > div * > ${Label},
      & > ${Link} > div > ${Label},
      & > ${MobileButtonLink} > div * > ${Label},
      & > ${MobileButtonLink} > div > ${Label},
      & > ${Label} {
        width: 240px;
        ${isNot('isSidebarOpen')`
          width: 0px;
          overflow: hidden;
          padding: 0px;
        `}
      }

      & > ${MenuList} {
        padding: unset;
      }
    }
  }
`

export default Sidebar

export interface ISidebarProps {
  isSidebarOpen?: boolean
  size?: number
}
